export default __webpack_public_path__ + "static/media/calendar@2x.87e5b9c0.webp";